// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth, signInWithPopup, GoogleAuthProvider, createUserWithEmailAndPassword} from "firebase/auth";
import {getFirestore, doc, getDoc, setDoc} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
apiKey: "AIzaSyC5hZuGXnO1J41fHkVqjGxAqMym2ImeiyA",
authDomain: "personal-website-a8842.firebaseapp.com",
projectId: "personal-website-a8842",
storageBucket: "personal-website-a8842.appspot.com",
messagingSenderId: "586576604337",
appId: "1:586576604337:web:03bee169ca7d5b58090690"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
    prompt: "select_account"
});

export const auth = getAuth();
export const signInWithGooglePopup = () => signInWithPopup(auth, googleProvider);

export const db = getFirestore();

export const createUserDocumentFromAuth = async (userAuth, additionalInformation={}) => {
    // verify authentication token was given
    if (!userAuth) {
        return;
    }
    // fetch that document in the "users" collection inside "db"
    const userDocRef = doc(db, "users", userAuth.uid);

    console.log(userDocRef);

    // snapshot contains the data, retrieve that data from the document
    const userSnapshot = await getDoc(userDocRef);

    console.log(userSnapshot);
    console.log(userSnapshot.exists());

    // if user data does not exist
    // create/set the document with the data from userAuth in my collection
    if (!userSnapshot.exists()) {
        const { displayName, email } = userAuth;
        const createdAt = new Date();

        // edit the data asynchronously
        try {
            
            /*
            <Modal a={this.props.a} b={this.props.b}/>
            is the same as
            <Modal {...this.props}/>
            */
            await setDoc(userDocRef, {
                displayName,
                email,
                createdAt,
                ...additionalInformation
            });
        } catch(error) {
            // error
            console.log("Error creating user", error.message);
        }
    }
    
    return userDocRef;
};

export const createAuthUserWithEmailAndPassword = async (email, password) => {
    // verify email/password was given
    if (!email || !password) {
        // stop this function
        return;
    }
    return await createUserWithEmailAndPassword(auth, email, password);
}